import React, { Component } from "react"
import * as dateHelper from "../../booking/helpers/date"
import * as endpoints from "../../api/endpoints"
import ReactHtmlParser from "react-html-parser"
import { isMobile } from "react-device-detect"
import da from "date-fns/locale/da"
import enGB from "date-fns/locale/en-GB"
import Svg from "../_svgs/svg"
import SearchOverlay from "../flight-search-hero/search-overlay"
import OutsideClickTrigger from "../../booking/components/common/OutsideClickTrigger"
import * as SelectionFactoryHelper from "../helpers/SelectionFactoryHelper"
import * as cookieHelper from "../../helpers/cookie"
import { DateTime } from "luxon"

export default class FlightSearchHeroSimple extends Component {
  constructor(props) {
    super(props)

    const dtLocale = dateHelper.luxonLocale(props.locale)
    const zone = "Europe/Copenhagen"
    const cphTimeConvert = DateTime.local().setLocale(dtLocale).setZone(zone) // gets local time and changes timezone to copenhagen to get correct time
    const cphTime = cphTimeConvert.setZone("local", { keepLocalTime: true }) // locks in copenhagen time and switches back to local timezone. This ensures the time will stay CPH time when we later converts the DateTime to a JS Date object.
    let startDate = cphTime.set({ milliseconds: 0, seconds: 0, minutes: 60 }).minus({ hours: 1 })
    let minDate = startDate.minus({ days: 1 })
    let minTime = cphTime.set({ hours: 0, minutes: 0, seconds: 0, milliseconds: 0 })
    let maxTime = cphTime.set({ hours: 23, minutes: 0, seconds: 0, milliseconds: 0 })

    this.state = {
      flights: [],
      direction: "D",
      q: "",
      showOverlay: false,
      searchDate: startDate,
      minDate: minDate,
      datepickerOpen: false,
      minTime: minTime,
      maxTime: maxTime,
      otherDaysMinTime: minTime,
      airports: [],
      airlines: [],
      mobileInputFocus: false,
      startDate: startDate,
    }
  }

  componentDidMount() {
    this.addEventListeners()
  }

  addEventListeners() {
    document.body.addEventListener("keydown", (e) => {
      let flightId = document.getElementById("flight-search-hero-input")
      let flightIsFocused = document.activeElement === flightId
      if (e.key === "Escape") {
        this.setState({ showOverlay: false })
        if (isMobile) {
          const elements = document.getElementsByClassName("site-header")
          const siteHeader = elements[0]
          if (siteHeader) {
            siteHeader.style.display = null
            let siteHeaderWrapper = document.getElementsByClassName("site-header-wrapper")[0]
            if (siteHeaderWrapper) {
              siteHeaderWrapper.style.height = siteHeader.clientHeight + "px"
            }
          }
          this.setZIndexOfNotificationBanner(null)
        }
        const input = document.querySelector("#flight-search-hero-input")
        if (input) {
          input.blur()
        }
      }
      if (e.key === "Enter" && this.state.q.length >= this.props.minCharsBeforeSearch && flightIsFocused) {
        window.location.href = `${this.state.direction === "D" ? this.props.departuresPage : this.props.arrivalsPage}?q=${
          this.state.q
        }&date=${this.state.searchDate.toFormat("dd / MM / yyyy")}&time=${this.state.searchDate.toFormat("HH")}`
      }
    })
  }

  search = async () => {
    if (this.state.q.length >= (this.props.minCharsBeforeSearch ?? 2)) {
      const dt = this.state.searchDate
      const zone = "Europe/Copenhagen"
      const cphTime = dt.setZone(zone, { keepLocalTime: true }) // set zone to copenhagen and keep local time, which is already cph time
      const start = cphTime.toUTC() // convert to UTC which is what Solr expects
      const end = cphTime.endOf("day").toUTC() // convert to UTC which is what Solr expects
      const flightsData = {
        direction: this.state.direction,
        query: this.state.q,
        startDateTime: start,
        endDateTime: end,
        language: this.props.locale,
      }

      // use this data and call GetAirports endpoint to get airports from solr core instead of flightinfo
      // const airportsData = { language: this.props.locale, query: this.state.q, limit: this.props.allFlightsLimit }
      const returns = await Promise.all([this.getFlights(flightsData), this.getAirports(flightsData)])
        .then((responses) => {
          return Promise.all(
            responses.map((response) => {
              return response
            }),
          )
        })
        .then((data) => {
          return data
        })
        .catch((err) => {
          console.log(err)
        })
      const flights = returns[0]
      const airports = returns[1]
      const airlines = this.getAirlines(flights)
      this.setState({ flights: flights, airports: airports, airlines: airlines })
    }
  }

  getFlights = (data) => {
    return endpoints
      .getFlightInfoTable(data)
      .then((res) => {
        return res.data
      })
      .then((data) => {
        let flights = []
        if (data) {
          flights = data
        }
        return flights
      })
      .catch((err) => {
        console.log(err)
      })
  }

  getAirports = (data) => {
    // return endpoints.getAirports(data)
    return endpoints
      .getAirportsFromFlights(data)
      .then((res) => {
        return res.data
      })
      .then((data) => {
        let airports = []
        if (data) {
          airports = data
        }
        return airports
      })
      .catch((err) => {
        console.log(err)
      })
  }

  getAirlines = (flights) => {
    let airlines = []
    if (flights && flights.length > 0) {
      const result = Array.from(new Set(flights.map((f) => f.IataAirline))).map((iata) => {
        return {
          iata: iata,
          name: flights.find((f) => f.IataAirline === iata).Airline,
          nameMobile: flights.find((f) => f.IataAirline === iata).AirlineMobile,
        }
      })
      airlines = result
    }
    return airlines
  }

  handleInput = (event, search = true) => {
    this.setState(
      {
        [event.target.name]: event.target.value,
      },
      () => {
        if (this.state.q.length >= 1) {
          if (isMobile && !this.state.showOverlay) {
            // scroll to top to fix the input field in the overlay being out of view on iphone
            window.scrollTo(0, 0)
            this.setZIndexOfNotificationBanner(0)
          }
          this.setState({ showOverlay: true }, () => {
            if (search) this.search()
            if (isMobile) {
              const elements = document.getElementsByClassName("site-header")
              const siteHeader = elements[0]
              if (siteHeader) {
                siteHeader.style.display = "none"
              }
            }
          })
        } else {
          if (!isMobile) {
            this.handleCloseOverlay()
          }
        }
      },
    )
  }

  handleDirectionChange = (direction, wasFocused) => {
    if (isMobile) {
      const input = document.getElementById("flight-search-hero-input")
      if (input && wasFocused) {
        input.focus()
        setTimeout(() => {
          this.setState({ mobileInputFocus: true })
        }, 20)
      }
    }
    this.setState({ direction: direction }, () => {
      this.search()
    })
  }

  handleCloseOverlay = () => {
    this.setState({ showOverlay: false, searchDate: this.state.startDate, q: "", flights: [], airports: [] }, () => {
      if (isMobile) {
        const elements = document.getElementsByClassName("site-header")
        const siteHeader = elements[0]
        if (siteHeader) {
          siteHeader.style.display = null
          let siteHeaderWrapper = document.getElementsByClassName("site-header-wrapper")[0]
          if (siteHeaderWrapper) {
            siteHeaderWrapper.style.height = siteHeader.clientHeight + "px"
          }
        }
        this.setZIndexOfNotificationBanner(null)
      }
    })
  }

  handleDateChange = (dateInput) => {
    this.setState(
      (prevState) => {
        let dateTime = DateTime.fromJSDate(dateInput)
        const startOfPrevDate = prevState.searchDate.startOf("day")
        const startOfMinDate = prevState.minDate.startOf("day")
        const startOfNewDate = dateTime.startOf("day")
        if (startOfMinDate.toMillis() === startOfNewDate.toMillis()) {
          // if the times are the same, meaning only the date was changed, set date to minDate
          const time = dateTime.toFormat("HH:mm")
          const prevTime = prevState.searchDate.toFormat("HH:mm")
          if (dateTime <= prevState.minDate || time === prevTime) {
            return { searchDate: prevState.minDate, minTime: prevState.minDate }
          }
          return { searchDate: dateTime, minTime: prevState.minDate }
        } else {
          // if the dates have changed, set time to 0
          if (startOfPrevDate.toMillis() !== startOfNewDate.toMillis()) dateTime = dateTime.set({ hours: 0, minutes: 0, seconds: 0, milliseconds: 0 })
          return { searchDate: dateTime, minTime: prevState.otherDaysMinTime }
        }
      },
      () => this.search(),
    )
  }

  handleDatepicker = () => {
    this.setState({ datepickerOpen: !this.state.datepickerOpen })
  }

  closeDatepicker = () => {
    this.setState({ datepickerOpen: false })
  }

  handleOutsideClick = () => {
    if (!this.state.overInput) {
      this.setState({ showOverlay: false, datepickerOpen: false })
    }
  }

  handleInputFocus = () => {
    if (this.state.q.length > 0) {
      if (isMobile && !this.state.showOverlay) {
        // scroll to top to fix the input field in the overlay being out of view on iphone
        window.scrollTo(0, 0)
        this.setZIndexOfNotificationBanner(0)
      }
      this.setState({ showOverlay: true }, () => {
        if (isMobile) {
          const elements = document.getElementsByClassName("site-header")
          const siteHeader = elements[0]
          if (siteHeader) {
            siteHeader.style.display = "none"
          }
        }
      })
    }
  }

  setZIndexOfNotificationBanner = (zindex) => {
    const notificationBanner = document.querySelector(".notification")
    if (notificationBanner) {
      const notificationVersion = notificationBanner.dataset.notificationVersion
      const notificationCookie = cookieHelper.getCookie(notificationVersion)
      if (notificationCookie !== "closed") {
        notificationBanner.style.zIndex = zindex
      }
    }
  }

  render() {
    let heroStyle = {}
    if (isMobile && this.props.backgroundImageMobile) {
      heroStyle = { backgroundImage: `url(${this.props.backgroundImageMobile})` }
    } else if (this.props.backgroundImage) {
      heroStyle = { backgroundImage: `url(${this.props.backgroundImage})` }
    }

    const icon = SelectionFactoryHelper.getFromSelectionFactory(this.props.icon)

    return (
      <section className={`deck deck--front`} style={heroStyle}>
        <header className="section-header section-header-search">
          <div className="section-header__inner">
            <div className="w--normal">
              <div className="leftside">
                <div className="infohead">{this.props.title}</div>
                {ReactHtmlParser(this.props.heading)}
                <div className="maintext">{this.props.mainText}</div>
              </div>
              <div className="flight-searchbox">
                <div className="headline">
                  {this.props.iconUpload ? <img src={this.props.iconUpload} alt={"icon"} /> : icon ? <Svg iconName={icon} /> : ""}
                  <span>{this.props.searchBoxTitle}</span>
                </div>
                <div className="form">
                  <div className="form__section form__section--light form__section--fat">
                    <div className={`form__section__inner ${isMobile && this.state.showOverlay ? "is-active" : ""}`}>
                      <div className="form__field form__field--text form__field--text-search form__field--text--no-label is-bound is-filled">
                        <span className="form__valid"></span>
                        <input
                          className="form__item"
                          id="flight-search-hero-input"
                          autoComplete="off"
                          autoCapitalize="none"
                          name="q"
                          type="text"
                          placeholder={isMobile ? this.props.searchBoxPlaceholderMobile : this.props.searchBoxPlaceholder}
                          value={this.state.q}
                          onChange={(e) => this.handleInput(e)}
                          onMouseEnter={() => this.setState({ overInput: true })}
                          onMouseLeave={() => this.setState({ overInput: false })}
                          onFocus={() => this.handleInputFocus()}
                        />
                        {!isMobile ? (
                          <button
                            className={`search-button ${this.state.showOverlay ? "active" : ""}`}
                            onClick={this.state.showOverlay ? this.handleCloseOverlay : undefined}
                          >
                            <div className={`search-icon`}></div>
                          </button>
                        ) : (
                          ""
                        )}
                        {isMobile && this.state.showOverlay ? (
                          <button onClick={this.handleCloseOverlay}>
                            <Svg iconName={"close"} fillColor={"#060e4d"} />
                          </button>
                        ) : (
                          ""
                        )}
                      </div>
                      <OutsideClickTrigger onOutsideClick={() => (isMobile ? undefined : this.handleOutsideClick())}>
                        <SearchOverlay
                          {...this.props}
                          {...this.state}
                          handleDirectionChange={this.handleDirectionChange}
                          handleDateChange={this.handleDateChange}
                          locale={this.props.locale === "da" ? da : enGB}
                          handleDatepicker={this.handleDatepicker}
                          closeDatepicker={this.closeDatepicker}
                          showTime={isMobile ? false : true}
                        />
                      </OutsideClickTrigger>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="clear"></div>
          </div>
        </header>
      </section>
    )
  }
}
